import { render } from "./elButtonTemp.vue?vue&type=template&id=47a81c5c"
import script from "./elButtonTemp.vue?vue&type=script&lang=js"
export * from "./elButtonTemp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__